import { AgGridReact } from "ag-grid-react";
import { useStateContext } from "contexts/auth-context";
import { BillingNoteReportType } from "generated/sales";
import { GraphQLClient } from "graphql-request";
import { useSnackbar } from "notistack";
import { RefObject, useState } from "react";
import { useTranslation } from "react-i18next";
import { createGraphQLClientWithMiddleware } from "services/graphqlClient";
import { BILLING_NOTE_GENERATE_REPORT } from "services/Sales/Report/GenerateReport";
import { dateFilterModel } from "utils/AgGridFilter";

export const useBillingNoteReport = (
  gridRef: RefObject<AgGridReact<any>>,
  reportType: BillingNoteReportType,
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const graphQLClientWithHeaderSales: GraphQLClient =
    createGraphQLClientWithMiddleware("sales");

  const {
    state: { authUser },
  } = useStateContext();

  const onBtnExport = async () => {
    setIsLoading(true);
    try {
      const filterModel: any = gridRef?.current?.api.getFilterModel();
      const sortModel = gridRef?.current?.columnApi
        .getColumnState()
        .filter((s) => s.sort !== null)
        .map(({ sort, colId }) => ({
          sort,
          colId,
        }));
      const formattedFilterModel = (reportType: BillingNoteReportType) => {
        if (reportType === BillingNoteReportType.BillingNoteByDeliveryItem) {
          const { issue_date, due_date, created_date, dt_issue_date } =
            filterModel;
          return {
            ...filterModel,
            issue_date: dateFilterModel(issue_date),
            due_date: dateFilterModel(due_date),
            created_date: dateFilterModel(created_date),
            dt_issue_date: dateFilterModel(dt_issue_date),
          };
        } else {
          return filterModel;
        }
      };

      const params: any = {
        aggridInput: {
          filterModel: formattedFilterModel(reportType),
          sortModel,
        },
      };

      const reportInput = {
        report_type: reportType,
        user_unique_id: authUser?.unique_id || "",
        params: params,
      };

      try {
        const { GenerateBillingNoteReport } =
          await graphQLClientWithHeaderSales.request(
            BILLING_NOTE_GENERATE_REPORT,
            { input: reportInput },
          );
        if (GenerateBillingNoteReport) {
          window.open(GenerateBillingNoteReport || "", "_blank");
          enqueueSnackbar(`${t("button.export")}สำเร็จ`, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(`${t("button.export")}ไม่สำเร็จ`, {
            variant: "error",
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        enqueueSnackbar(`${t("button.export")}ไม่สำเร็จ`, {
          variant: "error",
        });
      }
    } catch (err) {
      enqueueSnackbar("นำออกข้อมูลไม่สำเร็จ", {
        variant: "error",
      });
    }
    setIsLoading(false);
  };

  return {
    onBtnExport,
    isLoading: isLoading,
  };
};
